export default __webpack_public_path__ + "static/media/wheelchair-tennis-green.871f3e90.png";